/* ==========================================================================
   GemofU: product cards with more than one colour show each colour's photo
   in turn (every 6.5 seconds), and the matching colour dot is marked.
   - Photos come from each colour's variant image (/products/<handle>.js),
     loaded only when the card scrolls into view.
   - Pauses while the shopper hovers or touches the card, and does nothing
     for shoppers who have asked their device to reduce motion.
   - Cards whose colours all share one photo are left alone.
   Loaded from snippets/gou-plus.liquid.
   ========================================================================== */
(function () {
  'use strict';
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var EVERY = 6500;
  var WIDTHS = [200, 300, 400, 500, 600, 700, 900];
  var cache = {};

  function sized(src, w) {
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }
  function srcset(src) {
    return WIDTHS.map(function (w) { return sized(src, w) + ' ' + w + 'w'; }).join(', ');
  }
  function handleOf(card) {
    var a = card.querySelector('a.product-loop__img-link, .product-loop__title a');
    var m = a && (a.getAttribute('href') || '').match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : null;
  }
  function load(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return cache[handle];
  }

  function setup(card) {
    if (card._gouCycle) return;
    card._gouCycle = true;
    var list = card.querySelector('.product-loop__swatch-options.color');
    var img = card.querySelector('.product-loop__img-link > .box-ratio img');
    var handle = handleOf(card);
    if (!list || !img || !handle) return;
    var dots = Array.prototype.slice.call(list.querySelectorAll('li[data-option-title]'));
    if (dots.length < 2) return;
    var names = dots.map(function (li) { return li.getAttribute('data-option-title'); });

    load(handle).then(function (p) {
      if (!p || !p.variants) return;
      // Which option holds the colours (Size may come first): the one whose
      // values include the dot names.
      var idx = -1;
      (p.options || []).forEach(function (o, i) {
        if (idx === -1 && (o.values || []).some(function (v) { return names.indexOf(v) !== -1; })) idx = i;
      });
      if (idx === -1) return;
      var steps = [], seen = {};
      dots.forEach(function (li) {
        var name = li.getAttribute('data-option-title');
        for (var i = 0; i < p.variants.length; i++) {
          var v = p.variants[i];
          if (v.options[idx] === name && v.featured_image && v.featured_image.src) {
            var src = v.featured_image.src.replace(/^https?:/, '');
            if (!seen[src]) { seen[src] = 1; steps.push({ li: li, src: src }); }
            break;
          }
        }
      });
      if (steps.length < 2) return;

      // Start with the photo already on the card, if it belongs to a colour.
      var cur = (img.getAttribute('src') || '').split('?')[0].replace(/^https?:/, '');
      var at = 0;
      steps.forEach(function (s, i) { if (s.src.split('?')[0].split('/').pop() === cur.split('/').pop()) at = i; });
      steps.forEach(function (s) { var pre = new Image(); pre.src = sized(s.src, 600); });

      function mark() {
        dots.forEach(function (li) { li.classList.remove('gou-cycle-on'); });
        steps[at].li.classList.add('gou-cycle-on');
      }
      function show() {
        img.style.transition = 'opacity .25s ease';
        img.style.opacity = '0';
        setTimeout(function () {
          img.removeAttribute('loading');
          img.setAttribute('srcset', srcset(steps[at].src));
          img.setAttribute('src', sized(steps[at].src, 600));
          img.style.opacity = '1';
        }, 250);
        mark();
      }
      mark();

      var paused = false, visible = false;
      card.addEventListener('mouseenter', function () { paused = true; });
      card.addEventListener('mouseleave', function () { paused = false; });
      card.addEventListener('touchstart', function () { paused = true; setTimeout(function () { paused = false; }, 4000); }, { passive: true });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (e) { visible = e[0].isIntersecting; }).observe(card);
      } else { visible = true; }

      setInterval(function () {
        if (paused || !visible || document.hidden) return;
        at = (at + 1) % steps.length;
        show();
      }, EVERY + Math.floor(Math.random() * 400)); // small offset so cards do not all flip at once
    });
  }

  function scan() {
    var cards = document.querySelectorAll('.product-loop__item');
    if (!('IntersectionObserver' in window)) { cards.forEach(setup); return; }
    if (!scan.io) {
      scan.io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { scan.io.unobserve(e.target); setup(e.target); }
        });
      }, { rootMargin: '200px' });
    }
    cards.forEach(function (c) {
      if (!c._gouCycleSeen) { c._gouCycleSeen = true; scan.io.observe(c); }
    });
  }

  function start() {
    scan();
    var t = null;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(scan, 300); })
      .observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
